export const CUST_AUDIT_TYPE = {
  VALUE_TYPE: 1,
  RATIO_TYPE: 2,
}

export const CUST_AUDIT_TYPE_NAME = {
  [CUST_AUDIT_TYPE.VALUE_TYPE]: 'VALUE_TYPE',
  [CUST_AUDIT_TYPE.RATIO_TYPE]: 'RATIO_TYPE',
}
/**
 * api 回傳的物件名稱
 */
export const CUST_AUDIT_TYPE_STR = {
  [CUST_AUDIT_TYPE.VALUE_TYPE]: 'custom',
  [CUST_AUDIT_TYPE.RATIO_TYPE]: 'ratio',
}
